import React, { Suspense, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  MoreDropdownMenu,
  SingleMenuItem,
  TopMenuEnum,
} from "./components/Common/WidgetMenuHelper";
import { useAppSelector } from "./store";
import MainHeader from "./components/Common/MainHeader";
import Footer from "./components/Common/Footer";
import { CrmMenuBar } from "./components/Dashboard/CrmMenuBar";
import { MainFloatingButton } from "./components/queryList/MainFloatingButton";
import defaultImage from "./asserts/images/crmDefaultImage.jpg";

const CrmWrapper: React.FC<{
  className?: string;
}> = (props) => {
  const { data, websiteMenu: enquiryFormRoutes } = useAppSelector(
    (state) => state.siteData
  );

  const fdLabel = "Flight Deals";
  const location = useLocation();
  const [websiteMenus, setWebsiteMenus] = useState<Array<any>>([]);
  // const defaultImg =
  // "url('https://ik.imagekit.io/m2f79jq3u/Portal_Themes/New_Project__1__lFbKADl0CR.png?updatedAt=1680522264095')";
  const bgImage = data?.brandingSettings?.frontPageImage?.Location
    ? `url(${data?.brandingSettings?.frontPageImage?.Location})`
    : `url(${defaultImage})`;

  const isEnquiryFormRoute = enquiryFormRoutes?.find((route) => {
    return location.pathname.toLowerCase().includes(route.key.toLowerCase());
  });

  useEffect(() => {
    if (data?.activeModules) {
      const menuList = {
        Flight: {
          enum: TopMenuEnum.flight,
          icon: "fas fa-plane",
          title: "Flights",
        },
        TourPackages: {
          enum: TopMenuEnum.packages,
          icon: "fas fa-umbrella-beach",
          title: "Tour Packages",
        },
        FixedDeparture: {
          enum: TopMenuEnum.prePurchased,
          icon: "fas fa-plane-departure",
          title: fdLabel,
        },
        VisaChecklist: {
          enum: TopMenuEnum.visaChecklist,
          icon: "fas fa-passport",
          title: "Visa Checklist",
        },
        // Activities: {
        //   enum: TopMenuEnum.activities,
        //   icon: "fas fa-skiing",
        //   title: "Activity Finder",
        // },
        Hotels: {
          enum: TopMenuEnum.hotels,
          icon: "fas fa-bed",
          title: "Hotels",
        },
        Bus: {
          enum: TopMenuEnum.bus,
          icon: "fas fa-bus",
          title: "Bus",
        },
        Train: {
          enum: TopMenuEnum.train,
          icon: "fas fa-subway",
          title: "Train",
        },
        Cruise: {
          enum: TopMenuEnum.cruise,
          icon: "fas fa-ship",
          title: "Cruise",
        },
        Insurance: {
          enum: TopMenuEnum.insurance,
          icon: "fas fa-hand-holding-heart",
          title: "Insurance",
        },

        FlightsForm: {
          enum: TopMenuEnum.flightsForm,
          icon: "fas fa-list",
          title: "Flight Enquiry",
        },
        OtherEnquiry: {
          enum: TopMenuEnum.otherEnquiry,
          icon: "fas fa-list",
          title: "Other Enquiry",
        },
        VisaEnquiry: {
          enum: TopMenuEnum.visaEnquiry,
          icon: "fas fa-list",
          title: "Visa Enquiry",
        },
      };

      const allMenus = Object.values(menuList).map((menuItem) => {
        return {
          key: menuItem.enum,
          component: <SingleMenuItem key={menuItem.enum} {...menuItem} />,
        };
      });

      const moreMenuStartsFrom = 4;

      const allActiveModules = data?.activeModules.filter((am, indx) => {
        let moduleName = am.siteModule.module_name;
        if (moduleName === TopMenuEnum.activities) {
          return false;
        }

        return am.whitelabel_visibility && am.siteModuleId !== 12;
      });

      const menuItems = allActiveModules
        .filter((am, indx) => {
          return indx < moreMenuStartsFrom;
        })
        .map((item, index) => {
          const foundMenuIndex = allMenus.findIndex((men) => {
            return men.key === item.siteModule.module_name;
          });
          return {
            ...allMenus[foundMenuIndex].component,
            key: index,
          };
        });

      if (allActiveModules.length > moreMenuStartsFrom) {
        const moreListItems = allActiveModules
          .filter((am, indx) => indx >= moreMenuStartsFrom)
          .map((actMod) => {
            return {
              ...menuList[actMod.siteModule.module_name],
            };
          });
        menuItems.push(
          <MoreDropdownMenu key={"moreDropdown"} listItems={moreListItems} />
        );
      }
      setWebsiteMenus(menuItems);
    }
  }, [data?.activeModules]);

  return (
    <React.Fragment>
      <MainHeader />
      {!isEnquiryFormRoute ? (
        <>
          <CrmMenuBar />
          <MainFloatingButton />

          <Outlet />
        </>
      ) : (
        <div
          style={{
            backgroundImage: bgImage,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: "auto",
            minHeight: "calc(100vh - 80px)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Suspense
            fallback={
              <div className="container loading-skeleton">
                <div className="row justify-content-center placeholder-opacity-min">
                  <span
                    className="placeholder col-6"
                    style={{ height: "50px" }}
                  ></span>
                  <span
                    className="placeholder col-12"
                    style={{ height: "250px" }}
                  ></span>
                </div>
              </div>
            }
          >
            <div className="App container my-5" id="module">
              <div className="form-menu-top">{websiteMenus}</div>
              <div id="search-form">
                <div className="tab-content" id="search">
                  <Outlet />
                </div>
              </div>
            </div>
          </Suspense>
        </div>
      )}
      <Footer />
    </React.Fragment>
  );
};

export default CrmWrapper;
